<div
  *ngIf="isOpen"
  class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
>
  <div
    class="bg-white p-6 rounded-lg shadow-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto"
  >
    <h2 class="text-2xl font-bold mb-6 text-gray-800 border-b pb-2">
      {{ title }}
    </h2>
    <div class="flex w-full justify-between mb-6">
      <button
        (click)="closeModal()"
        class="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded"
      >
        Cancelar
      </button>
      <button
        (click)="updateItem()"
        class="bg-blue-500 text-white font-semibold px-4 py-2 rounded hover:bg-blue-600"
      >
        Guardar
      </button>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      <div *ngFor="let field of fields">
        <label class="block text-sm font-medium text-gray-700 mb-1">{{
          field.label
        }}</label>

        <!-- Campo "clave" con visibilidad de contraseña -->
        <div *ngIf="field.key === 'clave'; else defaultField">
          <div class="relative">
            <input
              [type]="showPassword ? 'text' : 'password'"
              [(ngModel)]="item[field.key]"
              class="border border-gray-300 rounded px-3 py-2 w-full mt-1 pr-10"
            />
            <button
              type="button"
              class="absolute inset-y-0 right-0 px-3 flex items-center justify-center text-gray-500 hover:text-gray-700"
              (click)="togglePasswordVisibility()"
            >
              <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
          </div>
          <small class="text-xs text-gray-500 mt-1 block">
            * Solo complete si desea cambiar la clave
          </small>
        </div>

        <!-- Otros campos -->
        <ng-template #defaultField>
          <!-- Inputs normales -->
          <input
            *ngIf="field.type !== 'checkbox' && field.type !== 'select'"
            [type]="field.type"
            [min]="field.min_date"
            [(ngModel)]="item[field.key]"
            class="border border-gray-300 rounded px-3 py-2 w-full mt-2"
          />
          <!-- Checkbox -->
          <input
            *ngIf="field.type === 'checkbox'"
            type="checkbox"
            [(ngModel)]="item[field.key]"
            class="ml-2 mt-2"
          />
          <!-- Select -->
          <select
            *ngIf="field.type === 'select'"
            [(ngModel)]="item[field.key]"
            class="border border-gray-300 rounded-md px-3 py-2 w-full mt-1 bg-white cursor-pointer"
          >
            <option *ngFor="let option of field.options" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
          <!-- date -->
        </ng-template>
      </div>
    </div>
  </div>
</div>
